
// messages.js
(function () {
  const messages = {
    error: {
      requiredFields: "Please review and complete the highlighted fields.",
      declarations: "Please accept all required declarations before submitting.",
      generic: "Something went wrong. Please try again."
    },
    success: {
      applicationSubmitted: "Thank you. Your application has been submitted successfully."
    },
    info: {
      saveStep: "Your answers in this step look good.",
      categoryChanged: "Question flow has been updated for your selected category."
    }
  };

  function ensureContainer() {
    let container = document.querySelector(".toast-container");
    if (!container) {
      container = document.createElement("div");
      container.className = "toast-container";
      document.body.appendChild(container);
    }
    return container;
  }

  function showToast(type, keyOrText, options = {}) {
    const container = ensureContainer();
    const group = messages[type] || {};
    const text = group[keyOrText] || keyOrText;
    if (!text) return;

    const iconClass =
      type === "success"
        ? "fa-circle-check"
        : type === "error"
        ? "fa-circle-exclamation"
        : "fa-circle-info";

    const toast = document.createElement("div");
    toast.className = `toast toast--${type}`;
    toast.innerHTML = `
      <div class="toast-icon">
        <i class="fa-solid ${iconClass}"></i>
      </div>
      <div class="toast-body">${text}</div>
    `;

    container.appendChild(toast);

    const duration = options.duration || 3600;
    setTimeout(() => {
      toast.classList.add("toast--hide");
      toast.addEventListener(
        "transitionend",
        () => toast.remove(),
        { once: true }
      );
    }, duration);
  }

  window.CareersMessages = messages;
  window.showCareerToast = showToast;
})();
